import React, {useState} from "react";
import "./Image.css";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  width: number | string;
  height: number | string;
  alt: string;
}

function Image({width, height, alt, ...props}: ImageProps) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setLoading(false);
    props.onLoad?.(e);
  };

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setLoading(false);
    setError(true);
    props.onError?.(e);
  };

  return (
    <div className="image" style={{width, height}}>
      {loading && !error && <div className="image__skeleton" />}

      {!error && (
        <img
          {...props}
          alt={alt}
          onLoad={handleLoad}
          onError={handleError}
          className={`image__image ${loading ? "image__image--hidden" : ""}`}
        />
      )}

      {error && <div className="image__error" />}
    </div>
  );
}

export default Image;
